import { Component } from '@angular/core';

import { NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public navigation: Router;

  constructor(private router: Router, private zone: NgZone) {
    this.navigation = router;
    this.initializeApp();
  }

  initializeApp() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        // Example url: https://3fivetwo.chunk.co.uk/audioplayer/123
        // slug = /tabs/tab2
        const slug = event.url.split('.uk').pop();
        if (slug) {
          this.router.navigateByUrl(slug);
        }
      });
    });
  }
}
